<template>
  <section>
    <div id="modal2" class="modal">
      <div class="modal-content">
        <h4>About</h4>
        <p>関西(大阪府、京都府、兵庫県、滋賀県、奈良県、和歌山県)で開催するIT勉強会を検索できるサイトです。</p>
        <p>新着情報をTwitterで知りたい場合は
          <a href="https://twitter.com/ItssKansai" target="_brank">@ItssKansai</a>
          をフォローしてください。
        </p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat">OK</a>
      </div>
    </div>

    <div id="modal1" class="modal bottom-sheet">
      <div class="modal-content">
        <input v-model="search_word" placeholder="検索ワード" id="search_word" type="text">
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat" v-on:click="search()">検索</a>
        <a href="#!" class="modal-close waves-effect waves-green btn-flat" v-on:click="search_clear()">クリア</a>
      </div>
    </div>

    <div class="toolbar-bottom">
      <ul>
        <li>
          <a class='dropdown-trigger' href='#' data-target='dropdown3'>
            <i class="material-icons">menu</i>
          </a>
          <ul id='dropdown3' class='dropdown-content dd3'>
            <li>
              <a class="li-sort" href="#" v-on:click="refresh()">データ再取得</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="clear()">条件初期化</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="modal-trigger" href="#" v-on:click="openModal('#modal2')">このサイトについて</a>
            </li>
          </ul>
        </li>
        <li>
          <a class="modal-trigger" href="#" v-on:click="openModal('#modal1')">
            <i class="material-icons">search</i>
          </a>
        </li>
        <li>
          <a class='dropdown-trigger' href='#' data-target='dropdown1'>
            <i class="material-icons">sort</i>
          </a>
          <ul id='dropdown1' class='dropdown-content'>
            <li>
              <a class="li-sort" href="#" v-on:click="sort_started_at_desc()">開催昇順</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="sort_started_at_asc()">開催降順</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="sort_updated_at()">更新順</a>
            </li>
          </ul>
        </li>
        <li>
          <a class='dropdown-trigger' href='#' data-target='dropdown2'>
            <i class="material-icons">filter_list</i>
          </a>
          <ul id="dropdown2" class="dropdown-content">
            <li>
              <a class="li-sort" href="#" v-on:click="filter_ken(0)">全て</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="filter_ken(27)">大阪</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-s1ort" href="#" v-on:click="filter_ken(26)">京都</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="filter_ken(28)">兵庫</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="filter_ken(25)">滋賀</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="filter_ken(29)">奈良</a>
            </li>
            <li class="divider"></li>
            <li>
              <a class="li-sort" href="#" v-on:click="filter_ken(30)">和歌山</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="item-container" @scroll="infiniteScroll">
      <a class='dropdown-trigger hidden' href='#' data-target='dropdown1'>aaa</a>
      <a class='dropdown-trigger hidden' href='#' data-target='dropdown2'>aaa</a>
      <a class='dropdown-trigger hidden' href='#' data-target='dropdown3'>aaa</a>
      <div v-show="loading" style="margin-top: 10px;font-size:2rem;height: 100px;width: 100%;">
        <span>loading...</span>
      </div>
      <div v-show="!loading" class="row">
        <div class="col s12" v-for="item in show_items" :key="item.id" @click="select(item.url)">
          <div class="card-panel lighten-5 z-depth-1" v-bind:class="{ isNotHoliday: item.isHoliday,isSaturday: item.isSaturday,isSunday: item.isSunday}" style="padding: 5px;margin: 0.1rem 0 0.1rem 0;">
            <div class="row valign-wrapper" style="margin-bottom: 0px;">
              <div class="col s2">
                <span style="font-size:0.7rem;margin-bottom: 0px;">
                  {{item.started_at.getFullYear()}}
                </span>
                <span style="font-size:1.3rem;margin-top: 0px;margin-bottom: 0px;">
                  {{item.started_at.getMonth()+1}}/{{item.started_at.getDate()}}
                </span>
                <span style="font-size:0.7rem;margin-top: 0px;margin-bottom: 0px;">
                  ({{item.week}}){{("0"+item.started_at.getHours()).slice(-2)}}:{{("0"+item.started_at.getMinutes()).slice(-2)}}
                </span>
              </div>
              <div class="col s8" style="text-align:left;">
                <span class="black-text" style="font-size:1.1rem;">
                  {{ item.title }}
                </span>
                <br>
                <span style="font-size:0.8rem;color:#333333;">
                  <b>【{{ ken[item.pref] }}】</b>{{ item.address }}
                </span>
              </div>
              <div class="col s2" style="text-align:right;padding-left:0px;">
                <span v-if="item.limit" class="black-text" style="font-size:1.4rem;">
                  {{ item.limit }}
                </span>
                <span v-if="!item.limit" class="black-text" style="font-size:2rem;">

                </span>
                <span class="black-text" style="font-size:0.7rem;">
                  人
                </span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const page_max = 75;
const ken = {
  1: "北海道",
  2: "青森",
  3: "岩手",
  4: "宮城",
  5: "秋田",
  6: "山形",
  7: "福島",
  8: "茨城",
  9: "栃木",
  10: "群馬",
  11: "埼玉",
  12: "千葉",
  13: "東京都",
  14: "神奈川",
  15: "新潟",
  16: "富山",
  17: "石川",
  18: "福井",
  19: "山梨",
  20: "長野",
  21: "岐阜",
  22: "静岡",
  23: "愛知",
  24: "三重",
  25: "滋賀",
  26: "京都",
  27: "大阪",
  28: "兵庫",
  29: "奈良",
  30: "和歌山",
  31: "鳥取",
  32: "島根",
  33: "岡山",
  34: "広島",
  35: "山口",
  36: "徳島",
  37: "香川",
  38: "愛媛",
  39: "高知",
  40: "福岡",
  41: "佐賀",
  42: "長崎",
  43: "熊本",
  44: "大分",
  45: "宮崎",
  46: "鹿児島",
  47: "沖縄"
};
export default {
  data() {
    return {
      items: [],
      sf_items: [],
      show_items: [],
      loading: true,
      pageing: 0,
      ken: ken,
      sort: "start_desc",
      filter: 0,
      search_word: "",
      search_list: []
    };
  },
  methods: {
    select: function(url) {
      open(url, "_blank");
    },
    infiniteScroll(event) {
      // スクロールの現在位置 + 親（.item-container）の高さ >= スクロール内のコンテンツの高さ
      if (
        event.target.scrollTop + event.target.offsetHeight >=
        event.target.scrollHeight - 20
      ) {
        const max_pageing = parseInt(this.show_items.length / page_max, 10) + 1;
        if (max_pageing >= this.pageing) {
          this.show_items.push(
            ...this.sf_items.slice(
              page_max * this.pageing,
              page_max * (this.pageing + 1)
            )
          );
          this.pageing++;
        }
      }
    },
    filter_ken: function(code) {
      this.filter = parseInt(code, 10);
      this.sort_filter();
    },
    sort_filter: function() {
      this.sf_items = this.items.slice();
      if (this.search_word != "") {
        const search_list = this.search_list;
        this.sf_items = this.sf_items.filter(function(item, index) {
          if (search_list.indexOf(item.id) >= 0) {
            return true;
          }
        });
      }
      if (this.filter != 0) {
        let ken_code = this.filter;
        this.sf_items = this.sf_items.filter(function(item, index) {
          if (item.pref == ken_code) return true;
        });
      }
      if (this.sort == "start_asc") {
        this.sf_items.sort(function(a, b) {
          if (a.started_at < b.started_at) return 1;
          if (a.started_at > b.started_at) return -1;
          return 0;
        });
      } else if (this.sort == "start_desc") {
        this.sf_items.sort(function(a, b) {
          if (a.started_at < b.started_at) return -1;
          if (a.started_at > b.started_at) return 1;
          return 0;
        });
      } else if (this.sort == "update_desc") {
        this.sf_items.sort(function(a, b) {
          if (a.updated_at < b.updated_at) return 1;
          if (a.updated_at > b.updated_at) return -1;
          return 0;
        });
      }
      this.show_items = this.sf_items.slice(0, page_max);
      this.pageing = 1;
    },
    sort_started_at_desc: function() {
      this.sort = "start_desc";
      this.sort_filter();
    },
    sort_started_at_asc: function() {
      this.sort = "start_asc";
      this.sort_filter();
    },
    sort_updated_at: function() {
      this.sort = "update_desc";
      this.sort_filter();
    },
    search: function() {
      if (this.search_word != "") {
        const that = this;
        that.loading = true;
        let thissearch_list = this.search_list;
        console.log("axios.get");
        axios
          .get(
            "https://asia-northeast1-itss-88a6d.cloudfunctions.net/main?sword=" +
              this.search_word
          )
          .then(res => {
            console.log("axios.then");
            console.log(res.data);
            that.loading = false;
            that.search_list = res.data.eid;
            that.sort_filter();
          });
      }
    },
    search_clear: function() {
      this.search_word = "";
      this.sort_filter();
    },
    openModal: function(mId) {
      var elem = document.querySelector(mId);
      const instance = M.Modal.getInstance(elem);
      instance.open();
    },
    clear: function() {
      this.search_word = "";
      this.sort = "start_desc";
      this.filter = 0;
      this.sort_filter();
    },
    refresh: function() {
      this.getData();
    },
    getData: function() {
      this.loading = true;
      const today = new Date();
      const self = this;
      const db = this.$store.state.firebase.database();

      let starCountRef = db
        .ref("event_lights/")
        .orderByChild("pref_group")
        .equalTo(5);
      starCountRef.once("value", function(snapshot) {
        const data = snapshot.val();
        let ret = [];
        for (let i in Object.values(data)) {
          let row = Object.values(data)[i];
          row.started_at = new Date(row.started_at);
          row.updated_at = new Date(row.updated_at);

          if (today <= row.started_at && row.ng != true) {
            let dayOfWeek = row.started_at.getDay();
            row.week = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek];
            row.isHoliday = false;
            row.isSunday = false;
            row.isSaturday = false;
            if(row.week == "土" ){
              row.isHoliday = true;
              row.isSaturday = true;
            }
            if(row.week == "日" ){
              row.isHoliday = true;
              row.isSunday = true;
            }
            row.title = row.title
              .replace("【大阪】", "")
              .replace("【京都】", "")
              .replace("【大阪・梅田】", "");
            ret.push(row);
          }
        }
        self.items = ret;
        self.sf_items = self.items.slice();
        self.show_items = ret.slice(0, page_max);
        self.loading = false;
        self.pageing = 1;
        self.sort_filter();
      });
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".dropdown-trigger");
      var instances = M.Dropdown.init(elems, {});
      var elems2 = document.querySelectorAll(".modal");
      var instances2 = M.Modal.init(elems2, {});
    });
  }
};
</script>


<style>
.hidden {
  display: none;
}
div.row {
  line-height: 1;
  margin-bottom: 30px;
}
.item-container {
  overflow: scroll;
  height: 100vh;
}
/* ToolBar */
.toolbar-bottom ul {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  top: 0;
  bottom: 0;
  z-index: 1;
  left: 0;
  right: 0;
  text-align: center;
  position: absolute;
  margin: 0;
}
.toolbar-bottom ul li {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: inline-block;
  margin: 0;
  height: 100%;
  -webkit-transition: none;
  transition: none;
}
.toolbar-bottom ul li a {
  display: block;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  line-height: 30px;
  z-index: 1;
}
.toolbar-bottom ul li a i {
  line-height: inherit;
}
.toolbar-bottom {
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  padding: 0;
  height: 30px;
  text-align: center;
  width: 100%;
  bottom: 0px;
  left: 0px;
  transition: transform 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53) 0s, background-color 0s linear 0.2s;
  overflow: hidden;
  background-color: #81c784;
}
.dd3 {
  width: auto !important;
}

.isNotHoliday {
  background-color: lightgray;
}
.isSaturday {
  background-color: #ffd6e1;
}
.isSunday {
  background-color: rgb(193, 231, 255);
}
</style>




// WEBPACK FOOTER //
// src/components/Kansai.vue